// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0cacac2c","455":"dd931f35","977":"a527b296"}[chunkId] + ".chunk.js";
};